import { useMemo } from 'react';
import { useProcessingDataExportDocument } from 'src/suitability-report/hooks/useProcessingDataExportDocument';
import { BackgroundProcess } from 'src/data-capture/hooks/file-uploads/types';

type MeetingNoteType = 'MEETING_NOTE';

type MeetingNote = {
  id: string;
  clientId: string;
  templateId?: string;
  createdAt: string;
  backgroundProcessId?: string;
  backgroundProcess?: BackgroundProcess;
  templatisedFileId?: number;
  documentHistoryId?: string;
  noteType: MeetingNoteType;
  fileName?: string;
  generatedFromAgenda: boolean;
  displayName: string;
  isGenerated: true;
};

type Props = {
  clientId?: string;
};

export const useMeetingNotes = ({ clientId }: Props = {}) => {
  const { items, isLoading, isError, error, refetch } = useProcessingDataExportDocument<
    Omit<MeetingNote, 'displayName' | 'isGenerated'>
  >({
    clientId,
    resource: 'meeting-notes',
  });

  const meetingNotes = useMemo(
    () =>
      items.map(note => {
        const isProcessing = ['PENDING', 'PROCESSING'].includes(
          note.backgroundProcess?.status || '',
        );
        const hasFileName = Boolean(note.fileName);

        let displayName: string;

        if (hasFileName) {
          displayName = note.fileName!;
        } else if (isProcessing) {
          displayName = '';
        } else {
          displayName = note.noteType
            .replace(/_/g, ' ')
            .toLowerCase()
            .replace(/\b\w/g, char => char.toUpperCase());
        }

        return {
          ...note,
          isGenerated: true,
          displayName,
        };
      }),
    [items],
  );

  return {
    meetingNotes,
    isLoading,
    isError,
    error,
    refetch,
  };
};
